import {Injectable} from '@angular/core';
import {createClient} from 'contentful';
import {environment} from '../../../environments/environment';
import {
    TypeCustomerLogosSkeleton,
    TypeCustomerLogosWithoutUnresolvableLinksResponse,
    TypeProjectDetailedSkeleton,
    TypeProjectDetailedWithoutUnresolvableLinksResponse,
    TypeProjectShowcaseSkeleton,
    TypeProjectShowcaseWithoutUnresolvableLinksResponse,
    TypeTestimonialSkeleton,
    TypeTestimonialWithoutUnresolvableLinksResponse,
} from '../types/contentful.types';
import {from, map} from 'rxjs';

export interface ContentfulData {
    showcasedProjects: TypeProjectShowcaseWithoutUnresolvableLinksResponse[];
    detailedProjects: TypeProjectDetailedWithoutUnresolvableLinksResponse[];
    testimonials: TypeTestimonialWithoutUnresolvableLinksResponse[];
    logos: TypeCustomerLogosWithoutUnresolvableLinksResponse[];
}

@Injectable({
    providedIn: 'root',
})
export class ContentfulService {
    private _client = createClient({
        space: environment.contentful.space,
        accessToken: environment.contentful.accessToken,
    });

    getShowcasedProjects() {
        return from(this._client.withoutUnresolvableLinks.getEntries<TypeProjectShowcaseSkeleton>({
            content_type: 'projectShowcase',
        })).pipe(map((res) => res.items));
    }

    getCustomerLogos() {
        return from(this._client.withoutUnresolvableLinks.getEntries<TypeCustomerLogosSkeleton>({
            content_type: 'customerLogos',
        })).pipe(map((res) => res.items));
    }

    getTestimonials() {
        return from(this._client.withoutUnresolvableLinks.getEntries<TypeTestimonialSkeleton>({
            content_type: 'testimonial',
        })).pipe(map((res) => res.items));
    }

    getDetailedProjects() {
        return from(this._client.withoutUnresolvableLinks.getEntries<TypeProjectDetailedSkeleton>({
            content_type: 'projectDetailed',
        })).pipe(map((res) => res.items));

    }
}
